export const getters = {
  systemStations: state => state.stations
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/stations/getters.js